import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { trackBar, BAR_TAPPED_KEY } from "@/lib/barTracking";

// Phone-only bar: appears once the anchor scrolls away, hides again when the footer is in view.
export default function MobileTryBar({ page = "home", anchor = '[data-testid="landing-try-cta"]' }) {
  const [heroGone, setHeroGone] = useState(false);
  const [footerIn, setFooterIn] = useState(false);

  useEffect(() => {
    const hero = document.querySelector(anchor);
    const footer = document.querySelector("footer");
    const obs = [];
    const watch = (el, fn) => {
      if (!el) return;
      const o = new IntersectionObserver(([e]) => fn(e));
      o.observe(el);
      obs.push(o);
    };
    watch(hero, (e) => setHeroGone(!e.isIntersecting && e.boundingClientRect.top < 0));
    watch(footer, (e) => setFooterIn(e.isIntersecting));
    return () => obs.forEach((o) => o.disconnect());
  }, [anchor]);

  const show = heroGone && !footerIn;
  const seen = useRef(false);

  useEffect(() => {
    if (show && !seen.current) {
      seen.current = true;
      trackBar("view", page);
    }
  }, [show, page]);

  const onTap = () => {
    trackBar("tap", page);
    try { window.sessionStorage.setItem(BAR_TAPPED_KEY, page); } catch { /* storage off */ }
  };
  return (
    <div
      className={`sm:hidden fixed inset-x-0 bottom-0 z-30 px-4 pb-[max(0.75rem,env(safe-area-inset-bottom))] pt-3 bg-obsidian-900/90 backdrop-blur-md border-t border-obsidian-600 transition-[transform,opacity] duration-300 ${show ? "translate-y-0 opacity-100" : "translate-y-full opacity-0 pointer-events-none"}`}
      data-testid="mobile-try-bar"
      data-visible={show ? "true" : "false"}
      aria-hidden={!show}
    >
      <Link
        to="/try"
        tabIndex={show ? 0 : -1}
        onClick={onTap}
        data-testid="mobile-try-bar-cta"
        className="flex items-center justify-center min-h-[44px] bg-terracotta hover:bg-terracotta-deep text-bone-100 font-sans text-xs uppercase tracking-[0.2em] transition-colors"
      >
        Try Chapter One — no account <ArrowRight className="ml-2 h-4 w-4" />
      </Link>
    </div>
  );
}
